/* eslint-disable @typescript-eslint/no-empty-function */
import { any, func, string } from 'prop-types';
import { Image, Menu, MenuHeader, MenuItem, MenuMenu } from 'semantic-ui-react';
import CheckedImg from 'Assets/images/pages/web-chat/checked.svg';
import React from 'react';

import css from './DevicePicker.less';

function CameraPicker({ activeCamera, selectCamera, cameras }) {
  return (
    <Menu vertical size="large">
      <MenuItem>
        <MenuHeader>
          <span className={css.header}>Select a Camera</span>
        </MenuHeader>
        {cameras.map(cam => (
          <MenuMenu key={cam.deviceId}>
            <MenuItem
              className={css.item}
              name={cam.label}
              active={activeCamera === cam.deviceId}
              onClick={() => selectCamera(cam.deviceId)}>
              {cam.label}
              {activeCamera === cam.deviceId && <Image src={CheckedImg} />}
            </MenuItem>
          </MenuMenu>
        ))}
      </MenuItem>
    </Menu>
  );
}

CameraPicker.propTypes = {
  activeCamera: string,
  selectCamera: func,
  cameras: any,
};

CameraPicker.defaultProps = {
  cameras: [],
  activeCamera: 'default',
  selectCamera: () => {},
};

export default CameraPicker;
